export default __webpack_public_path__ + "static/media/networking-share-svgrepo-com.dfac7f9c.svg";